import { CollectionAction } from '../collection-action.interface';
import { CollectionState } from '../collection-state.interface';

const onDeleteSuccess = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => ({
  ...state,
  listOfCollections: state.listOfCollections.filter(
    (collection) => collection.collectionId !== action.collectionId,
  ),
  defaultCollectionId:
    action.collectionId === state.defaultCollectionId
      ? undefined
      : state.defaultCollectionId,
  isUpdating: false,
});

export default onDeleteSuccess;
